let cache;
/**
 * Загрузчик js скриптов для подключения стафф карточек.
 */
export const loader = (src) => {
    if (cache) {
        return cache;
    }
    cache = new Promise((resolve, reject) => {
        const { StaffCard, StaffLiteCard } = window;
        if (StaffCard || StaffLiteCard) {
            return resolve();
        }
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.onload = function () {
            resolve();
        };
        script.onerror = () => {
            reject(new URIError(`Can't load staff card script "${script.src}"`));
            cache = null;
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
        document.head.appendChild(script);
    });
    return cache;
};
